var map = {
	"./dark/business.svg": "d84f",
	"./dark/church-holiday.svg": "b301",
	"./dark/community.svg": "dfad",
	"./dark/complex-event.svg": "58ea",
	"./dark/cultural.svg": "bc3ac",
	"./dark/entertaining.svg": "137f",
	"./dark/family.svg": "5522",
	"./dark/news-conference.svg": "ab76",
	"./dark/none.svg": "6b57",
	"./dark/political.svg": "d16e",
	"./dark/public-holiday.svg": "e77e",
	"./dark/scientific.svg": "9b17",
	"./dark/social-event.svg": "20d7",
	"./dark/sport.svg": "bdf7",
	"./light/business.svg": "e173",
	"./light/church-holiday.svg": "6847",
	"./light/community.svg": "05a4",
	"./light/complex-event.svg": "f29a",
	"./light/cultural.svg": "bd7e",
	"./light/entertaining.svg": "8548",
	"./light/family.svg": "638e",
	"./light/news-conference.svg": "32ea",
	"./light/none.svg": "19ab",
	"./light/political.svg": "a83f",
	"./light/public-holiday.svg": "52ba",
	"./light/scientific.svg": "8eb3",
	"./light/sheet.svg": "289d",
	"./light/social-event.svg": "f40a",
	"./light/sport.svg": "8067"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85d5";